import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-mist py-12 sm:py-16" aria-labelledby="guarantee-heading" data-id="element-117" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-118" data-mp="9tbhr6ox76n1">
        <p className="inline-flex items-center gap-2 rounded-full bg-green-soft px-5 py-2 font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-green-deep" data-id="element-119" data-mp="et65509hle3c">
          <ShieldCheckIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-120" data-mp="jqg4b7moh44d" />
          Tu inversión está 100% protegida
        </p>

        <h2 id="guarantee-heading" className="mx-auto mt-6 max-w-2xl font-display text-[2rem] font-bold leading-[1.12] text-ink sm:text-[2.6rem]" data-id="element-121" data-mp="skcc1hf3ie09">
          Garantía de 7 días, sin preguntas
        </h2>

        <div className="mt-8 rounded-3xl border border-line bg-shell px-6 py-8 sm:px-10" data-id="element-122" data-mp="12kbnbm2wgigt">
          <p className="mx-auto max-w-readable font-sans text-[0.95rem] leading-relaxed text-muted sm:text-base" data-id="element-123" data-mp="17iwllfylcs2m">
            Recibes exactamente lo que te mostramos y prometemos. Si dentro de
            los 7 días el contenido entregado no corresponde con la descripción
            de esta página, solicitas tu devolución y{' '}
            <span className="font-medium text-ink" data-id="element-124" data-mp="1vvtyct0szn0f">te reembolsamos el 100%</span>
            .
          </p>

          <p className="mt-6 inline-flex rounded-full bg-mist px-5 py-2.5 font-sans text-[0.85rem] font-medium text-ink" data-id="element-125" data-mp="1ruihpczwqc4d">
            Tasa de devoluciones: menor al 0,5%
          </p>
        </div>
      </div>
    </section>;
}